import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const ResetPasswordConfirm = () => {
  const { uidb64, token } = useParams();
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [reNewPassword, setReNewPassword] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== reNewPassword) {
      setError("Passwords do not match");
      return;
    }
   

    const url = `https://mysite-dtzs.onrender.com/api/reset-password-confirm/${uidb64}/${token}/`;
    const payload = {
      new_password: newPassword,
      re_new_password: reNewPassword,
    };

    try {
      const response = await axios.post(url, payload);
      if (response.status === 200 || response.status === 204) {
        setSuccess(true);
        setError(null);
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("Reset password confirm error:", err);
      if (err.response?.data) {
        const data = err.response.data;
        if (data.new_password) {
          setError(data.new_password.join(" "));
        } else if (data.re_new_password) {
          setError(data.re_new_password.join(" "));
        } else if (data.token) {
          setError("Invalid or expired token.");
        } else {
          setError("Failed to reset password. Please try again.");
        }
      } else {
        setError("Something went wrong.");
      }
    }
  };

  return (
    <div className="container d-flex align-items-center justify-content-center min-vh-100 ">
      <div className="card shadow-lg p-4" style={{ maxWidth: "500px", width: "100%" }}>
        <h3 className="text-center mb-4">Reset Password</h3>

        {success ? (
          <div className="alert alert-success text-center">
            Password reset successful! Redirecting to login...
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">New Password</label>
              <input
                type="password"
                className="form-control"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                minLength={6}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Confirm New Password</label>
              <input
                type="password"
                className="form-control"
                value={reNewPassword}
                onChange={(e) => setReNewPassword(e.target.value)}
                required
                minLength={6}
              />
            </div>

            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}

            <button type="submit" className="btn btn-success w-100">
              Reset Password
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordConfirm;
